import {
    STATISTICS_QUIZ_ROUTE,
    STATISTICS_QUIZ_SUCCESS,
    DOWNLOAD_QUIZ_STATISTICS_EXPORT_FILE,
    DOWNLOAD_QUIZ_STATISTICS_EXPORT_FILE_SUCCESS
} from './constants';

/**
 *
 * @param fromToDates
 * @param quizId
 * @returns {{fromToDates: *, quizId: *, type: string}}
 */
const ststisticsQuiz = ( fromToDates, quizId ) => ( {
    type: STATISTICS_QUIZ_ROUTE,
    quizId, fromToDates
} );

/**
 *
 * @param ststistics
 * @returns {{ststistics: *, type: string}}
 */
const ststisticsQuizSuccess = ststistics => {
    return ( {
        type: STATISTICS_QUIZ_SUCCESS,
        ststistics
    } );
};

/**
 *
 * @param fromToDatesObj
 * @param quizId
 * @returns {{fromToDatesObj: *, quizId: *, type: string}}
 */
const downloadStatisticsExportFile = ( fromToDatesObj, quizId ) => ( {
    type: DOWNLOAD_QUIZ_STATISTICS_EXPORT_FILE,
    quizId,
    fromToDatesObj
} );
/**
 *
 * @param fileLink
 * @returns {{fileLink: *, type: string}}
 */

const downloadStatisticsExportFileSuccess = fileLink => ( {
    type: DOWNLOAD_QUIZ_STATISTICS_EXPORT_FILE_SUCCESS,
    fileLink
} );

export {
    ststisticsQuiz,
    ststisticsQuizSuccess,
    downloadStatisticsExportFile,
    downloadStatisticsExportFileSuccess
};
